module.exports = __webpack_public_path__ + "static/media/Montserrat-SemiBold.bbcd5bbb.ttf";